<template>
  <NorticSelect
    ref="eventSelector"
    v-model="innerValue"
    class="event-select"
    is-filterable
    :filter="eventFilterFunction"
    :list-max-height-nr-of-items="10"
    list-max-height-item-height="1em"
    :placeholder="placeholder"
    @change="emitChangeEvent"
  >
    <template #header="{ updateFilter }">
      <EventFilter
        :initial-filter="initialEventFilter"
        @filter-update="updateFilter"
      />
    </template>
    <template #list>
      <NorticSelectItem
        v-for="event in events"
        :key="event.id"
        :label="event.name"
        :value="event"
      >
        <div
          class="event"
        >
          <EventStatusBall :status="event.statusType" />
          <div class="name">
            {{ event.name }}
          </div>
        </div>
      </NorticSelectItem>
    </template>
  </NorticSelect>
</template>

<script>
import NorticSelect from '@/components/common/input/nortic-select/NorticSelect.vue';
import EventFilter from '@/components/common/input/event-selector-v3/EventFilter.vue';
import EventStatusBall from '@/components/common/status-ball/EventStatusBall.vue';
import NorticSelectItem from '@/components/common/input/nortic-select/nortic-select-item/NorticSelectItem.vue';
import dynamicCustomInput from '@/components/common/input/mixins/dynamicCustomInput';

const eventFilterFunction = (filterValue, event) => {
  if (!filterValue) {
    return true;
  }

  const doesValueMatchActiveFilter = () => (filterValue.onlyActive
    ? (event.statusType === 'STATUS_ACTIVE')
    : true);
  const doesValueIncludeFilterText = () => event?.name?.toLocaleLowerCase().includes(filterValue.text.toLocaleLowerCase());

  return doesValueMatchActiveFilter() && doesValueIncludeFilterText();
};
export default {
  name: 'EventSelectorEventSelect',
  components: {
    NorticSelectItem, EventStatusBall, EventFilter, NorticSelect,
  },
  mixins: [dynamicCustomInput({ autoEmit: true })],
  props: {
    events: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: 'Välj evenemang',
    },
  },
  data() {
    return {
      eventFilterFunction,
      initialEventFilter: {
        text: '',
        onlyActive: true,
      },
    };
  },
  mounted() {
    this.triggerInitialEventFilter();
  },
  methods: {
    emitChangeEvent(e) {
      this.$emit('change', e);
    },
    triggerInitialEventFilter() {
      if (this.$refs.eventSelector.updateFilter) {
        this.$refs.eventSelector.updateFilter(this.initialEventFilter);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .event {
    display: grid;
    grid-template-columns: min-content 1fr;
    grid-gap: 10px;
    align-items: center;
    position: relative;

    .name {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
</style>
